import { Box, ButtonGroup } from "@material-ui/core";
import React from "react";
import { DetailButton } from "../../../../../Components/DetailButton";

export const Actions = props => {
  return (
    <Box style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "8px" }}>
      <ButtonGroup variant="text" size="small">
        <DetailButton {...props} path={"eightwings"} />
      </ButtonGroup>
    </Box>
  );
};
export default Actions;
